import { render, staticRenderFns } from "./ProductoEmpresaUpdate.vue?vue&type=template&id=436f29a4&scoped=true&"
import script from "./ProductoEmpresaUpdate.vue?vue&type=script&lang=js&"
export * from "./ProductoEmpresaUpdate.vue?vue&type=script&lang=js&"
import style0 from "./ProductoEmpresaUpdate.vue?vue&type=style&index=0&id=436f29a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../frontend-new/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436f29a4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../frontend-new/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAlert,VBtn,VCard,VChip,VCol,VDivider,VIcon,VRow,VSpacer,VTextField})
